/* tslint:disable */
/* eslint-disable */
export enum PatientDefaultPage {
  Dashboard = 0,
  Timeline = 1
}
